import { themed } from "@smartsheet/sds-theme-internal";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { borderTheme } from "./getButtonBorderRadius";
var focusRingTheme = themed({
  offset: {
    "lodestar-light": 2,
    "ursa-light": 1
  }
});
export var getButtonFocusRingStyles = function getButtonFocusRingStyles(_ref) {
  var themeMode = _ref.themeMode,
    size = _ref.size;
  return createFocusRingStyles({
    gap: focusRingTheme.offset(themeMode),
    componentBorderWidth: 1,
    componentRadius: borderTheme[size](themeMode),
    theme: themeMode
  });
};
//# sourceMappingURL=getButtonFocusRingStyles.js.map